var map = {
	"./bitcoin.svg": "ddae",
	"./cards-int.svg": "f73a",
	"./cards-ru.svg": "425d",
	"./crypto.svg": "8716",
	"./cryptomus.svg": "22e0",
	"./doge.svg": "e6b9",
	"./erip.svg": "0fac",
	"./master-ap-gp.svg": "723a",
	"./master-mir.svg": "9a67",
	"./mastercard.svg": "6f0b",
	"./mir.svg": "b496",
	"./sberpay.svg": "f847",
	"./sbp.svg": "9d7a",
	"./skinify.svg": "04d1",
	"./skinsback.svg": "b664",
	"./tether.svg": "751c",
	"./ton.svg": "5f36",
	"./visa-ap-gp.svg": "b862",
	"./visa.svg": "c548",
	"./xrp.svg": "2c8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59cf";